import { Feature } from "./Feature";
import {Product} from "./Product"
import {PriceService} from "./PriceService"

export class FeatureSpecial extends Feature{
    private productIndex = 0;
    constructor(name:string, product:Product, product2:Product, hasAnimation:boolean, imagePaths:string[], modelList:string[]){
        super(name, product, hasAnimation, imagePaths, modelList);
        this.product2 = product2;
    }

    private product2:Product;

    public toogleModel(indicator?:string){
        if(indicator === "Tischbrenner"){
            switch (this.productIndex){
                case 0:{
                    this.productIndex = 2;
                    this.modelListON[0].visibility = false;
                    this.modelListON[1].visibility = true;
                    break;
                }
                case 1:{
                    this.productIndex = 2;
                    this.modelListON[0].visibility = false;
                    this.modelListON[1].visibility = true;
                    break;
                }
                case 2:{
                    this.productIndex = 0;
                    this.modelListON[0].visibility = false;
                    this.modelListON[1].visibility = false;
                    break;
                }
    
            }
            PriceService.instance.calculatePrice();
        }
        else{
            switch (this.productIndex){
                case 0:{
                    this.productIndex = 1;
                    this.modelListON[0].visibility = true;
                    this.modelListON[1].visibility = false;
                    break;
                }
                case 2:{
                    this.productIndex = 1;
                    this.modelListON[0].visibility = true;
                    this.modelListON[1].visibility = false;
                    break;
                }
                case 1:{
                    this.productIndex = 0;
                    this.modelListON[0].visibility = false;
                    this.modelListON[1].visibility = false;
                    break;
                }
    
            }
            PriceService.instance.calculatePrice();
        }
        
    }

    public getImagePath():string{
        switch (this.productIndex){
            case 0:{
                return this.imagePaths[0];
                break;
            }
            case 1:{
                return this.imagePaths[1];
                break;
            }
            case 2:{
                return this.imagePaths[2];
                break;
            }

        }
    }

    public getProduct():Product{
        switch (this.productIndex){
            case 0:{
                // console.log("NONE");
                return null;
            }
            case 2:{
                // console.log("Product: ", this.product.getPrice());
                return this.product;
            }
            case 1:{
                // console.log("Product: ", this.product.getPrice());
                return this.product2;
            }
            default:{
                // console.log("NONE");
                return null;
            }
        }
    }
    
    public getProductForAddingPrice():Product[]{
        return [this.product, this.product2];
    }
}